import { MaintenanceCom } from "components";

function Maintenance() {
  return (
    <div>
      <MaintenanceCom />
    </div>
  );
}

export default Maintenance;
